import 'css-chunksrc/client/scenes/resourceEdition/projects/styles.scss';export default {
  "projects": "_projects_hsdn9_1",
  "header": "_header_hsdn9_10",
  "main": "_main_hsdn9_16",
  "list": "_list_hsdn9_22",
  "project": "_project_hsdn9_1",
  "icon": "_icon_hsdn9_40",
  "name": "_name_hsdn9_48"
};